import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { colors } from "../../Assets/styles/colors";
import { ReactComponent as CloseIcon } from "../../Assets/iconsv2/generic/closeBtn.svg";
import { ReactComponent as Crown } from "../../Assets/icons/subscription/crown.svg";
import { ReactComponent as PlatformIcon } from "../../Assets/iconsv2/generic/BusinessUser.svg";

import { useAuthService } from "../../Context/AuthContext";
import moment from "moment";
import DeleteConfirmationChild from "../GenericComponents/DeleteConfirmationChild";
import SubscriptionPlanPicker from "../Subscription/SubscriptionPlanPicker";
import SubscribedPlanCard from "../Subscription/SubscribedPlanCard";
import { useTranslate } from '@tolgee/react';
import {
  SUBSCRIPTION_LEVEL_PLATFORM,
  SUBSCRIPTION_LEVEL_PREMIUM,
  SUBSCRIPTION_LEVEL_PRO,
  SUBSCRIPTION_LEVEL_REFERRALS,
  SUBSCRIPTION_LEVEL_ULTRA,
} from "../../Constants/constantValues";
import PrimaryButton from "../GenericComponents/PrimaryButton";

const SubscriptionModal = ({
  handleClose,
  handleSubscribeClick,
  handleUnSubscribeClick,
  handleSetInvitations,
}) => {
  const { hadFreeTrial, checkSubscriptions, subscription, subscriptionLevel, offering } =
    useAuthService();

  const [subscribeTo, setSubscribeTo] = useState("premium");
  const [payYearly, setPayYearly] = useState(false);

  const [userHadFreeTrial, setUserHadFreeTrial] = useState(null);

  const [openConfirmation, setOpenConfirmation] = useState(false);
  const { t } = useTranslate();
  const SubscribeTitle = t('subscription_modal.subscribe_title');
  const PremiumTitle = t('subscription_modal.premium_title');
  const PlatformTitle = t('subscription_modal.platform_title');

  const JoinText = t('subscription_modal.join_text');
  const JoinedTex = t('subscription_modal.joined_text');

  const navigateToLandingPageLink = (to) => {
    let url = "http://emotii.ai";
    window.open(`${url}/${to}`);
  };

  const handleHadFreeTrial = () => {
    hadFreeTrial(
      (response) => {
        const resp = response.data.had_free_trial;
        setUserHadFreeTrial(resp);
      },
      (error) => {
        console.log(error);
      }
    );
  };

  useEffect(() => {
    handleHadFreeTrial();
    checkSubscriptions();
  }, []);

  return (
    <FullScreenItem>
      <Card>
        <Line>
          <Title>
            {subscription ? (
              <>
                {subscriptionLevel === SUBSCRIPTION_LEVEL_PLATFORM
                  ? <PlatformIcon style={{ height: "24px", width: "24px" }} />
                  : <Crown style={{ height: "24px", width: "24px" }} />
                }
                {(subscriptionLevel === SUBSCRIPTION_LEVEL_PRO ||
                  subscriptionLevel === SUBSCRIPTION_LEVEL_PREMIUM ||
                  subscriptionLevel === SUBSCRIPTION_LEVEL_ULTRA ||
                  subscriptionLevel === SUBSCRIPTION_LEVEL_REFERRALS) &&
                  PremiumTitle}
                {subscriptionLevel === SUBSCRIPTION_LEVEL_PLATFORM &&
                  PlatformTitle}
              </>
            ) : (
              SubscribeTitle
            )}
          </Title>
          <CloseBtn onClick={handleClose}>
            <CloseIcon />
          </CloseBtn>
        </Line>

        <Line>
          <InfoText>
            {(subscriptionLevel === SUBSCRIPTION_LEVEL_PRO ||
              subscriptionLevel === SUBSCRIPTION_LEVEL_PREMIUM ||
              subscriptionLevel === SUBSCRIPTION_LEVEL_ULTRA ||
              subscriptionLevel === SUBSCRIPTION_LEVEL_REFERRALS) &&
              JoinedTex}
            {!subscription && JoinText}
          </InfoText>
        </Line>

        {subscription ? (
          <SubscribedPlanCard
            subscription={subscription}
            subscriptionLevel={subscriptionLevel}
            offering={offering}
          />
        ) : (
          <SubscriptionPlanPicker
            subscribeTo={subscribeTo}
            setSubscribeTo={setSubscribeTo}
            sendInvites={handleSetInvitations}
            payYearly={payYearly}
            setPayYearly={setPayYearly}
          />
        )}

        <Line>
          {subscription && subscription.willRenew
            ? subscription.store === "stripe" && (
              <DeleteConfirmationChild
                action={handleUnSubscribeClick}
                setOpen={setOpenConfirmation}
                open={openConfirmation}
                variant={"unsubscribe"}
              >
                <PrimaryButton
                  style={{ padding: "16px", width: "100%" }}
                  onClick={() => setOpenConfirmation(true)}>
                  {t('general.unsubscribe')}
                </PrimaryButton>
              </DeleteConfirmationChild>
            )
            : subscription?.expirationDate && (
              <InfoText style={{ color: colors.purple }}>
                {t('subscription_modal.active_until')}{" "}
                {moment(subscription.expirationDate).format("DD/MM/YYYY")}
              </InfoText>
            )}

          {!subscription && (
            <PrimaryButton
              style={{ padding: "16px", width: "100%" }}
              onClick={() => handleSubscribeClick(subscribeTo, payYearly)}
            >
              {userHadFreeTrial === false &&
                subscribeTo === SUBSCRIPTION_LEVEL_PREMIUM &&
                t('subscription_modal.start3Days')
              }
              {userHadFreeTrial === true &&
                t('subscription_modal.subscribe')
              }

            </PrimaryButton>

          )}
        </Line>

        <Line>
          <TermsBtn onClick={() => navigateToLandingPageLink("terms/")}>
            {t('general.terms_and_conditions')}
          </TermsBtn>
        </Line>
      </Card>
    </FullScreenItem>
  );
};

export default SubscriptionModal;

const FullScreenItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  left: 0;
  top: 0;
  padding: 20px;
  z-index: 2;
`;
const Card = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 200px;
  max-width: 500px;
  width: 100%;
  max-height: 100%;
  background: ${({ theme }) => theme.menu.background};
  border-radius: 4px;
  padding: 30px;

  position: relative;
  gap: 20px;
  overflow: auto;
`;
const Line = styled.div`
  display: flex;
  width: 100%;
  gap: 20px;
  align-items: center;
  svg {
    max-height: 40px;
    width: fit-content;
  }
`;

const Title = styled.h1`
  font-size: 20px;
  font-weight: 500;
  line-height: 24px;
  color:${({ theme }) => theme.menu.primaryTextColor};
  align-items: center;
  display: flex;
  gap: 10px;
`;


const CloseBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: none;
  cursor: pointer;
  margin-left: auto;
  svg{
height:28px;
width:28px;
color:${({ theme }) => theme.menu.selectedOpionBackground};
stroke:${({ theme }) => theme.sidebar.borderColor};
}
`;
const InfoText = styled.h1`
  font-size: 14px;
  line-height: 22px;
  font-weight: 400;
  color:${({ theme }) => theme.menu.secondaryTextColor};
`;
const SmallInfor = styled(InfoText)`
  font-size: 12px;
  line-height: 18px;
`;

const TermsBtn = styled(SmallInfor)`
  cursor: pointer;
  color:${({ theme }) => theme.menu.selectedTextColor};
`;
